import { useState } from 'react';
import { ToastTypes } from '../components/toast/Toast';

export const useToast = () => {
  const [isToastVisible, setIsToastVisible] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<string>();
  const [toastType, setToastType] = useState<ToastTypes>();

  const showToast = (message: string, type: ToastTypes = 'INFO') => {
    setToastMessage(message);
    setIsToastVisible(true);
    setToastType(type);
  };

  const closeToast = () => {
    setIsToastVisible(false);
    setToastMessage(undefined);
    setToastType(undefined);
  };

  return {
    isToastVisible,
    toastMessage,
    showToast,
    closeToast,
    toastType,
  };
};
